import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DetailsConfig } from '../../interface/License-details';

@Component({
  selector: 'app-license-details',
  templateUrl: './license-details.component.html',
  styleUrl: './license-details.component.scss',
  standalone: false,
})
export class LicenseDetailsComponent {
  @Input() config!: DetailsConfig;

  @Output() actionTriggered = new EventEmitter<{ action: string; row: any }>();

  onAction(action: string, row: any) {
    this.actionTriggered.emit({ action, row });
  }

  ngOnInit() {
    console.log(this.config);
  }
}
